import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=9a3794ea"
import script from "./demo2.vue?vue&type=script&lang=js"
export * from "./demo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports